import { cn } from '@/lib/utils';

interface StatCardProps {
  value: string | number;
  label: string;
  accent?: 'primary' | 'secondary' | 'emerald' | 'blue' | 'muted';
  className?: string;
}

const accentMap: Record<string, { value: string; bg: string }> = {
  primary: { value: 'text-primary', bg: 'bg-primary/[0.04]' },
  secondary: { value: 'text-secondary', bg: 'bg-secondary/[0.06]' },
  emerald: { value: 'text-emerald-600', bg: 'bg-emerald-50/80' },
  blue: { value: 'text-blue-600', bg: 'bg-blue-50/80' },
  muted: { value: 'text-foreground', bg: 'bg-muted/40' },
};

export default function StatCard({
  value,
  label,
  accent = 'muted',
  className,
}: StatCardProps) {
  const colors = accentMap[accent];
  return (
    <div
      className={cn(
        'rounded-xl border border-border/50 p-5',
        colors.bg,
        className,
      )}
    >
      <p
        className={cn(
          'font-bold tracking-tight',
          typeof value === 'number' || String(value).length <= 6
            ? 'text-2xl sm:text-3xl'
            : 'text-base sm:text-lg',
          colors.value,
        )}
      >
        {value}
      </p>
      <p className="mt-1 text-xs font-medium text-muted-foreground uppercase tracking-wider">
        {label}
      </p>
    </div>
  );
}
